import { MutationTree } from 'vuex'
import { Notification } from './types'
import { getDefaultState } from '@/store/notifications/index'

export const mutations: MutationTree<Notification> = {
  setEmailsNotification(state, { agentId, fullName }) {
    state.emailsNotification.push({ agentId, fullName })
  },
  setGroupEmailsNotification(state, { agentId, groupName, color }) {
    state.groupEmailsNotification.push({ agentId, groupName, color })
  },
  resetState(state) {
    Object.assign(state, getDefaultState())
  }
}
